<script lang="ts">
    import cx from 'classnames';
    import InputWrapper from './InputWrapper.svelte';

    export let id: string;
    export let label: string;
    export let value: string = null;
    export let customClass: string = '';
    export let inline: boolean = false;
    export let allowEmpty: boolean = true;

    $: isValid = allowEmpty || Boolean(value);
</script>

<InputWrapper id={id} label={label} inline={inline} customClass={customClass}>
    <input
        type="text"
        bind:value={value}
        id={id}
        class={cx('form-control', {'is-invalid': !isValid})}
    />
    <div class="invalid-feedback">
        Prosím, vyplňte.
    </div>
</InputWrapper>